import { Control, ControllerProps, FieldError, useController } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';
import { useApplication } from 'contexts/ApplicationContext';
import TextField from './TextField';

interface CustomFieldsPlaceholderFieldProps {
  control: Control;
  label: string;
  disabled: boolean;
  validationRules: ControllerProps['rules'];
  readOnly: boolean;
}

const CustomQuestion = ({ name, label, control, disabled, validationRules, readOnly }) => {
  const {
    field: { value: formValue, onChange },
    formState: { errors },
  } = useController({
    name,
    control,
    rules: validationRules,
    disabled,
  });

  const {
    state: {
      // @ts-expect-error TS(2339): Property 'custom_questions' does not exist on type... Remove this comment to see the full error message
      application: { custom_questions: questions, custom_question_answers: answers },
    },
  } = useApplication();

  // This is needed when rendering a custom fields placeholder field in a step summary. Since in this case we don't have
  // the values for the answers in the form, we need to get the value from the custom question answers directly
  const value = formValue || answers[questions[name]];

  return <TextField disabled={disabled} name={name} label={label} value={value} onChange={onChange} error={errors[name] as FieldError} readOnly={readOnly} />;
};

const CustomFieldsPlaceholderField = ({ control, label, disabled, validationRules, readOnly }: CustomFieldsPlaceholderFieldProps) => {
  const {
    state: {
      // @ts-expect-error TS(2339): Property 'custom_questions' does not exist on type... Remove this comment to see the full error message
      application: { custom_questions: questions },
    },
  } = useApplication();

  return (
    questions && (
      <Stack data-cy-field-type="custom-fields-placeholder">
        <Typography variant="h5" component="h2" mb={2}>
          {label}
        </Typography>
        {Object.keys(questions).map((questionId) => {
          const questionLabel = questions[questionId];
          return (
            questionLabel && (
              <CustomQuestion
                key={questionId}
                disabled={disabled}
                name={questionId}
                label={questionLabel}
                control={control}
                validationRules={validationRules}
                readOnly={readOnly}
              />
            )
          );
        })}
      </Stack>
    )
  );
};

export default CustomFieldsPlaceholderField;
